import React from 'react';
import styles from './bodywon.module.css';

const OrderTotalsSummary = ({
  totals,
  formatPrice,
  subtotalLabel = 'Subtotal (without tax)',
  grandLabel = 'Grand Total',
  showTax = true,
}) => (
  <div className={styles.orderTotalsBox}>
    {totals.bundleDiscount > 0 ? (
      <>
        <div className={styles.orderTotalRow}>
          <span>Original price</span>
          <span>{formatPrice(totals.originalSubtotal)}</span>
        </div>
        <div className={styles.orderTotalRow}>
          <span>Bundle discount</span>
          <span>-{formatPrice(totals.bundleDiscount)}</span>
        </div>
      </>
    ) : null}
    <div className={styles.orderTotalRow}>
      <span>{subtotalLabel}</span>
      <span>{formatPrice(totals.subtotal)}</span>
    </div>
    {showTax &&
      (totals.taxLines ?? []).map((line) => (
        <div key={line.key} className={styles.orderTotalRow}>
          <span>{line.label}</span>
          <span>{formatPrice(line.amount)}</span>
        </div>
      ))}
    <div className={`${styles.orderTotalRow} ${styles.orderTotalGrand}`}>
      <span>{grandLabel}</span>
      <span>{formatPrice(totals.grandTotal)}</span>
    </div>
  </div>
);

export default OrderTotalsSummary;
